export default __webpack_public_path__ + "static/blog-rating-card-bg-685d8736449a1c074c71481c53f139a4.png";